import { useEffect } from "react";
import type { JSX } from "react";
import { Outlet, useNavigate } from "react-router";
import { appUrlToPath } from "./nativeAuth";
import { usePlatform } from "./PlatformContext";

/**
 * Root route element that opens the application path of URLs delivered to the native app (login
 * and logout callbacks through the app URI scheme) and of tapped push notifications. In the
 * browser it only renders the child routes.
 *
 * @returns The child routes.
 */
export function AppUrlNavigation(): JSX.Element {
  const platform = usePlatform();
  const navigate = useNavigate();

  useEffect(() => {
    const stopUrls = platform.onAppUrlOpen((url) => {
      const path = appUrlToPath(url);

      if (path !== null) {
        void navigate(path, { replace: true });
      }
    });
    const stopNotifications = platform.onNotificationOpened((path) => {
      void navigate(path);
    });
    const unsubscribe = (): void => {
      stopUrls();
      stopNotifications();
    };

    return unsubscribe;
  }, [platform, navigate]);

  const outlet = <Outlet />;

  return outlet;
}
